import React from 'react'
import { useCallback } from 'react'
import styled from '@emotion/styled'
import { Input } from 'modules/ui/atoms/Input'
import { Tooltip } from 'modules/ui/atoms/Tooltip'
import Label from 'modules/ui/atoms/Typography/Label'
import { DEFAULT_FONT_STYLES, DEFAULT_THEME_COLORS } from 'css/theme'
import { getAnalyticsInstance } from '../../analytics/analytics'
import { useTranslation } from 'next-i18next'

interface CopyToClipboardFieldProps {
  label: string
  value: string
}

const CopyToClipboardField = (props: CopyToClipboardFieldProps) => {
  const [copied, setCopied] = React.useState(false)

  const analytics = getAnalyticsInstance()
  const { t } = useTranslation()

  const onCopy = useCallback(() => {
    // Track the click event
    analytics.track('copy_link_click', {
      label: props.label,
      value: props.value,
    })

    navigator.clipboard.writeText(props.value)

    setCopied(true)

    setTimeout(() => {
      setCopied(false)
    }, 500)
  }, [analytics, props.label, props.value])

  const copyButtonEL = (
    <CopyToClipboardFieldButton onClick={onCopy} data-id="social-panel-copy-link-button">
      {props.label}
    </CopyToClipboardFieldButton>
  )

  return (
    <div>
      <Label size="sm">{props.label}</Label>
      <CopyToClipboardFieldRow>
        <div style={{ flex: 1 }}>
          <Input
            leftIcon="link"
            value={props.value}
            onChange={() => {
              // do nothing
            }}
            dataId="social-panel-copy-link-input"
          />
        </div>
        {copied ? (
          <Tooltip text={t('copyToClipboardField.linkCopied', 'Link Copied')} placement="top">
            {copyButtonEL}
          </Tooltip>
        ) : (
          <>{copyButtonEL}</>
        )}
      </CopyToClipboardFieldRow>
    </div>
  )
}

export default CopyToClipboardField

const CopyToClipboardFieldRow = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`

const CopyToClipboardFieldButton = styled.button`
  height: 42px;
  border-radius: 8px;
  padding-inline: 24px;
  border-width: 0;
  color: white;
  cursor: pointer;
  background: ${DEFAULT_THEME_COLORS['--theme-color--neutral-10']};
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-sm__font-size']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--title-page-sm__font-weight']};
`
